<i (click)="onClick()" class="wep-ag-grid-cell-renderer-icon__icon {{getClass()}}"></i>
